import React from 'react';

import { UNIT_DAYS, UNIT_HOURS } from './summaryUnits';

import Button from 'CommonComponents/Button';
import SegmentedControl from 'CommonComponents/SegmentedControl';
import SelectInput from 'CommonComponents/SelectInput';

import DownloadIcon from 'Assets/icons/download.svg';

export const PERIOD_LAST_6_WEEKS = 'last_6_weeks';
export const PERIOD_THIS_MONTH = 'this_month';
export const PERIOD_LAST_MONTH = 'last_month';
export const PERIOD_CUSTOM = 'custom';

const PERIOD_OPTIONS = () => [
    { value: PERIOD_LAST_6_WEEKS, label: $t('Last 6 weeks') },
    { value: PERIOD_THIS_MONTH, label: $t('This month') },
    { value: PERIOD_LAST_MONTH, label: $t('Last month') },
    { value: PERIOD_CUSTOM, label: $t('Custom range') },
];

export default function TimeSummaryFilters({ filters, projects, unit, onChange, onUnitChange, onDownload, downloadDisabled }) {
    return (
        <div className="tw-flex tw-flex-wrap tw-items-end tw-gap-x-4 tw-gap-y-3">
            <div>
                <label htmlFor="time_summary_period" className="tw-block tw-text-xs tw-text-charcoal-50 tw-mb-1">
                    {$t('Period')}
                </label>
                <SelectInput
                    id="time_summary_period"
                    name="time_summary_period"
                    value={filters.period}
                    onChange={(event) => onChange({ period: event.target.value })}
                >
                    {PERIOD_OPTIONS().map((option) => (
                        <option key={option.value} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                </SelectInput>
            </div>

            {filters.period === PERIOD_CUSTOM && (
                <>
                    <div>
                        <label htmlFor="time_summary_from" className="tw-block tw-text-xs tw-text-charcoal-50 tw-mb-1">
                            {$t('From')}
                        </label>
                        <input
                            id="time_summary_from"
                            type="date"
                            value={filters.from || ''}
                            max={filters.to || undefined}
                            onChange={(event) => onChange({ from: event.target.value })}
                            className="tw-border-2 tw-border-grey tw-rounded-lg tw-text-sm tw-p-1.5"
                        />
                    </div>
                    <div>
                        <label htmlFor="time_summary_to" className="tw-block tw-text-xs tw-text-charcoal-50 tw-mb-1">
                            {$t('To')}
                        </label>
                        <input
                            id="time_summary_to"
                            type="date"
                            value={filters.to || ''}
                            min={filters.from || undefined}
                            onChange={(event) => onChange({ to: event.target.value })}
                            className="tw-border-2 tw-border-grey tw-rounded-lg tw-text-sm tw-p-1.5"
                        />
                    </div>
                </>
            )}

            <div>
                <label htmlFor="time_summary_project" className="tw-block tw-text-xs tw-text-charcoal-50 tw-mb-1">
                    {$t('Project')}
                </label>
                <SelectInput
                    id="time_summary_project"
                    name="time_summary_project"
                    value={filters.project}
                    onChange={(event) => onChange({ project: event.target.value })}
                >
                    <option value="">{$t('All projects')}</option>
                    {projects.map((project) => (
                        <option key={project.id} value={project.id}>
                            {project.name}
                        </option>
                    ))}
                </SelectInput>
            </div>

            <SegmentedControl
                options={[
                    { value: UNIT_HOURS, label: $t('Hours') },
                    { value: UNIT_DAYS, label: $t('Days') },
                ]}
                value={unit}
                onChange={onUnitChange}
            />

            <Button variant="secondary" disabled={downloadDisabled} onClick={onDownload}>
                <DownloadIcon className="tw-h-3 tw-w-3" />
                {$t('Download')}
            </Button>
        </div>
    );
}
